// extracted by mini-css-extract-plugin
export default {"h2":"vp_KsXbw","marginNone":"vp_R6HwR"};